import { Divider } from '../../elements/Divider';

interface ImportLocationsHeaderProps {
  title?: string;
  description?: string;
}
export const ImportLocationsHeader = ({
  title = 'Importing Locations',
  description = 'Before uploading your CSV, please review the information below.',
}: ImportLocationsHeaderProps) => (
  <div className='w-full'>
    <div className='p-4'>
      <h1 className='text-gray-800 text-lg font-semibold'>{title}</h1>
      <p className='text-gray-600 text-sm'>{description}</p>
    </div>
    <Divider />
  </div>
);
